import React, { Component } from 'react'
import { PageContainer } from '@toolpad/core/PageContainer'
import ProcessTable from '../../../components/admin_portal/process/ProcessTable'
import CreateProcess from '../../../components/admin_portal/process/CreateProcess'
import ProcessPageToolbar from '../../../components/admin_portal/process/ProcessPageToolbar'

export class ProcessContainer extends Component {

  handleProcessModal = (newVal, c_action) => {
    this.props.setProcessModalOpen(newVal);
    this.props.setAction(c_action)
  }

  handleProcessUpdateModal = async (newVal, c_action, process_id) => {
    let res = await this.props.get_process_details(process_id)
    if (res && !res.error) {
      this.props.setProcessModalOpen(newVal);
      this.props.setAction(c_action)
      this.props.setId(process_id)
    }
  };

  handleProcessSubmit = async (payload) => {
    let res = await this.props.create_process(payload);
    return res;
  };

  handleProcessUpdate = async (payload) => {
    let res = await this.props.update_process(payload);
    return res;
  };

  handleActivateDeactivateProcess = async (payload) => {
    let res = await this.props.activate_deactivate_process(payload);
    return res;
  };


  render() {
    const {
      is_process_modal_open,
      common_loading,
      total_process_count,
      page,
      c_action,
      process_id,
      selected_data,
    } = this.props;
    return (
      <PageContainer maxWidth='xl' slots={{
        toolbar: ProcessPageToolbar,
      }} title={""} sx={{
        '& .css-lc31tn > .MuiTypography-h4': {
          fontSize: '14px',
          alignSelf: { md: 'center', xs: 'flex-start' },
        },
        '& .css-lc31tn': {
          bgcolor: theme => theme.palette.grey[200],
          px: 1.5,
          py: 0.1,
          borderRadius: '10px',
          my: 1.5,
          flexDirection: { md: 'row', xs: 'column' },
          alignItems: { md: 'unset', xs: 'flex-start' }
        },
        '& .css-1hwxlk6': {
          width: { md: 'unset', xs: '100%' },
          flexDirection: { md: 'row', xs: 'column' },
          marginLeft: { md: 'auto', xs: 'unset!important' }
        },
      }}>
        <ProcessTable
          total_process_count={total_process_count}
          is_loading={common_loading}
          page={page}
          is_process_modal_open={is_process_modal_open}
          handleProcessUpdateModal={this.handleProcessUpdateModal}
          activate_deactivate_process={this.handleActivateDeactivateProcess}
        />
        <CreateProcess
          is_process_modal_open={is_process_modal_open}
          handleProcessModal={this.handleProcessModal}
          handleProcessSubmit={this.handleProcessSubmit}
          handleProcessUpdate={this.handleProcessUpdate}
          is_loading={common_loading}
          c_action={c_action}
          process_id={process_id}
          selected_data={selected_data}
        />
      </PageContainer>
    )
  }
}

export default ProcessContainer
